import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { ArrowRight } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AnimatedNumber from "../../common/components/AnimatedNumber";
import Button from "../../common/components/Button";
import CardChartMenu from "../../common/components/CardChartMenu";
import ChartRenderer from "../../common/components/ChartRenderer";
import { SPACING } from "../../common/constants/spacing";
import { useSettings } from "../../common/contexts/SettingsContext";
import {
  CHART_CONFIGS,
  formatChartLabels,
  getChartTitle,
} from "../../common/config/chartConfig";
import { GraphColorPalette } from "./GraphColorPalette";

export const RevenueCard = ({
  analytics,
  chartType,
  allowedChartTypes,
  onChartTypeChange,
  cardKey,
  configKey,
}) => {
  const { setShowTotalRevenueCard, setrevenueGraphColor, revenueGraphColor } =
    useSettings();
  const [showGraphColorPalette, setShowGraphColorPalette] = useState(false);
  const navigate = useNavigate();

  const granularity = analytics?.granularity || "monthly";
  const timeStats = analytics?.time_stats || [];
  const labels = formatChartLabels(timeStats, granularity);
  const dataValues = timeStats.map((item) => item.royalty_revenue);
  const chartTitle = getChartTitle("impression_revenue", granularity);

  return (
    <>
      <Grid size={{ md: 4, xs: 12 }}>
        <Card
          variant="outlined"
          sx={{ height: "100%", display: "flex", flexDirection: "column" }}
        >
          <CardContent sx={{ flexGrow: 1, pb: "12px !important" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: SPACING.md,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  textTransform: "uppercase",
                  fontWeight: 500,
                  fontSize: "0.875rem",
                  color: "text.secondary",
                }}
              >
                Revenue in last 5 months
              </Typography>
              <CardChartMenu
                onHide={() => setShowTotalRevenueCard(false)}
                onColorChange={() => setShowGraphColorPalette(true)}
                chartType={chartType}
                allowedChartTypes={allowedChartTypes}
                onChartTypeChange={onChartTypeChange}
                cardKey={cardKey}
                configKey={configKey}
              />
            </Box>
            <Box sx={{ mb: 3, pl: 1 }}>
              <Typography variant="h1" sx={{ fontWeight: "bold" }}>
                <AnimatedNumber
                  section="dashboardCards"
                  value={analytics?.total_royalty_revenue}
                  isCurrency
                />
              </Typography>
            </Box>

            <Box sx={{ width: "100%", maxWidth: "700px", margin: "auto" }}>
              <ChartRenderer
                chartType={chartType}
                labels={labels}
                dataValues={dataValues}
                color={revenueGraphColor}
                chartTitle={chartTitle}
                chartOptions={CHART_CONFIGS.standard}
              />
            </Box>

            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                variant="text"
                size="small"
                onClick={() => navigate("/analytics")}
                sx={{
                  textTransform: "none",
                  color: "primary.main",
                  py: 0.3,
                  mt: SPACING.sm,
                  fontSize: "1rem",
                }}
                endIcon={<ArrowRight size={18} />}
              >
                View details
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Grid>
      <GraphColorPalette
        showGraphColorPalette={showGraphColorPalette}
        setShowGraphColorPalette={setShowGraphColorPalette}
        onSelectColor={setrevenueGraphColor}
      />
    </>
  );
};
